import { render } from "./CallsGridView.vue?vue&type=template&id=e53607f4&scoped=true"
import script from "./CallsGridView.vue?vue&type=script&lang=js"
export * from "./CallsGridView.vue?vue&type=script&lang=js"

import "./CallsGridView.vue?vue&type=style&index=0&id=e53607f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e53607f4"]])

export default __exports__